import { Icon } from "@/components/Icon";
import type { IconProps } from "@/types";
import type { ReactElement } from "react";

export function MultiSelectIcon<
  RC extends ReactElement | undefined = undefined,
>({ rc, ...props }: IconProps<RC>) {
  return <Icon {...props} rc={rc} />;
}
